import { render, staticRenderFns } from "./ItemHint.vue?vue&type=template&id=1fc6c386&scoped=true"
import script from "./ItemHint.vue?vue&type=script&lang=js"
export * from "./ItemHint.vue?vue&type=script&lang=js"
import style0 from "./ItemHint.vue?vue&type=style&index=0&id=1fc6c386&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc6c386",
  null
  
)

export default component.exports